'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Utensils, Camera, Users, Trophy } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const activities = [
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '07:00 – 09:00',
  title: 'Ăn sáng',
  desc: 'Bữa sáng khởi đầu ngày mới.',
  accent: '#e8a030'
},
{
  icon: <Camera size={18} className="text-[#4caf7d]" />,
  time: '09:00 – 12:15',
  title: 'Hoạt động tự do – ghi hình',
  desc: 'Check-in, quay vlog, ghi lại hành trình.',
  accent: '#4caf7d'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '12:15 – 14:00',
  title: 'Ăn trưa – nghỉ ngơi',
  desc: 'Bữa trưa và thời gian nghỉ ngơi phục hồi năng lượng.',
  accent: '#e8a030'
},
{
  icon: <Users size={18} className="text-[#a8d87a]" />,
  time: '14:00 – 17:00',
  title: 'Team building',
  desc: 'Hoạt động vận động, tăng gắn kết đội nhóm.',
  accent: '#a8d87a'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '17:00 – 19:00',
  title: 'Ăn tối – sinh hoạt cá nhân',
  desc: 'Bữa tối và thời gian tự do cá nhân.',
  accent: '#e8a030'
},
{
  icon: <Trophy size={18} className="text-[#f5c96a]" />,
  time: '19:00 – 22:00',
  title: 'Đêm thi tài năng tổng hợp',
  desc: 'Biểu diễn, trao giải và tạo cao trào năng lượng.',
  accent: '#f5c96a'
}];


export default function Slide12eDay6({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1722385036869-09e072ecca6c"
          alt="Nhóm bạn trẻ vui vẻ cùng nhau trong hoạt động ngoài trời, năng lượng tích cực và gắn kết"
          className="w-full h-full object-cover opacity-8" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a2a]/70 via-[#0a1a0f] to-[#0a1a0f]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(245,201,106,0.3)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge amber">
            <span className="w-1.5 h-1.5 rounded-full bg-[#f5c96a] inline-block" />
            Hành trình 8 ngày 7 đêm
          </div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(24px,3.5vw,48px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            NGÀY 6
          </h2>
          <h2 className="font-display font-800 text-[clamp(18px,2.5vw,32px)] leading-[1.3] tracking-tight text-gradient-amber">
            Tự do – Team Building – Đêm tài năng
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#e8a030] to-[#f5c96a] rounded-full" />
        </div>

        <div className="relative fade-in-up">
          <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gradient-to-b from-[#f5c96a]/60 via-[#4caf7d]/40 to-transparent" />
          <div className="flex flex-col gap-4">
            {activities.map((act, i) =>
            <div key={`d6-${i}`} className="flex items-start gap-4 pl-2">
                <div
                className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center z-10"
                style={{ background: `${act.accent}22`, border: `1.5px solid ${act.accent}55` }}>
                
                  {act.icon}
                </div>
                <div
                className="flex-1 rounded-xl p-4 transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: `${act.accent}0d`, border: `1px solid ${act.accent}22` }}>
                
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span
                    className="font-body font-700 text-[11px] tabular-nums px-2 py-0.5 rounded-full"
                    style={{ color: act.accent, background: `${act.accent}18` }}>
                    
                      {act.time}
                    </span>
                    <h3 className="font-display font-700 text-[14px] lg:text-[15px] text-[#f0ede6]">
                      {act.title}
                    </h3>
                  </div>
                  <p className="font-body text-[12px] lg:text-[13px] text-[#a0b8a8] leading-relaxed">
                    {act.desc}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SlideWrapper>);

}